// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SelectSubject/SelectSubjectResult.less
// module id = 1672
// module chunks = 0